import type { Video } from "@/types/video";

export type SortKey = "latest" | "likes" | "comments";

export function sortVideos(list: Video[], sort: SortKey): Video[] {
  const copy = [...list];
  if (sort === "likes") {
    return copy.sort((a, b) => b.likes - a.likes);
  }
  if (sort === "comments") {
    return copy.sort((a, b) => b.comments - a.comments);
  }
  return copy.sort(
    (a, b) => new Date(b.uploadDate).getTime() - new Date(a.uploadDate).getTime()
  );
}

export function paginate<T>(items: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return items.slice(start, start + pageSize);
}

export function searchVideos(list: Video[], keyword: string): Video[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return list.filter((video) => {
    const haystack = `${video.title} ${video.description} ${video.tags.join(" ")}`.toLowerCase();
    return haystack.includes(key);
  });
}